import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { usersApi } from "../../api/Instances";
const END_POINT = process.env.REACT_APP_BASE_URL_PERMISSIONS;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}

const add = (type) => {
    return ({
        type: type
    })
}

const delelte = (type) => {
    return ({
        type: type
    })
}

const edit = (type) => {
    return ({
        type: type
    })
}

export const postVisitor = (state, setLoad) => {
    return async (dispatch) => {
        setLoad(true);
        try {
            const response = await usersApi.post(`/api/visitors`, state);
            if (response.data.status === "Success") {
                dispatch(add(types.ADD_VISITOR));
                dispatch(loadVisitors());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoad(false);
        }
    };
};

export const loadVisitors = () => {
    return async (dispatch) => {
        try {
            const response = await usersApi.get(`/api/visitors`);
            if (response.data.status === "Success") {
                dispatch(get(response.data.data, types.GET_VISITORS));
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Failed to load visitors");
        }
    };
};

export const deleteVisitor = (id, setLoadDel, setIsDeleted, setIdDeleted) => {
    return async (dispatch) => {
        setLoadDel(true);
        try {
            const response = await usersApi.delete(`/api/visitors/${id}`);
            if (response.data.status === "Success") {
                dispatch(delelte(types.DELETE_VISITOR));
                notifysuccess(response.data.message);
                setIsDeleted("deleted");
                setIdDeleted(id);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error deleting visitor");
        } finally {
            setLoadDel(false);
        }
    };
};

export const putVisitor = (id, first_name, last_name, phone_number, email, password, setLoad) => {
    return async (dispatch) => {
        setLoad(true);
        const formValues = {
            first_name,
            last_name,
            phone_number,
            email,
        };
        if (password !== "") {
            formValues.password = password;
        }
        try {
            const response = await usersApi.put(`/api/visitors/${id}`, formValues);
            if (response.data.status === "Success") {
                dispatch(edit(types.EDIT_VISITOR));
                dispatch(loadVisitors());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error updating visitor");
        } finally {
            setLoad(false);
        }
    };
};

export const filterVisitor = (first_name, last_name, email, setLoad) => {
    return async (dispatch) => {
        setLoad(true);
        const queryParams = [];
        if (first_name !== "") queryParams.push(`filters[first_name]=${first_name}`);
        if (email !== "") queryParams.push(`filters[email]=${email}`);
        if (last_name !== "") queryParams.push(`filters[last_name]=${last_name}`);
        const finalQuery = queryParams.join("&");
        const apiUrl = `/api/visitors?${finalQuery}`;
        try {
            const response = await usersApi.get(apiUrl);
            dispatch(get(response.data.data, types.GET_VISITORS));
        } catch (error) {
            console.error("Filter Visitor Error:", error.response?.data?.message || error.message);
        } finally {
            setLoad(false);
        }
    };
};

export const blockVisitor = (id, status, setLoad) => {
    return async (dispatch) => {
        setLoad(true);
        try {
            const response = await usersApi.put(`/api/visitors/${id}/update-status`, { status });
            if (response.data.status === "Success") {
                dispatch(edit(types.BLOCK_VISITOR));
                dispatch(loadVisitors());
                notifysuccess(response.data.message);
            }
        } catch (error) {
            notifyError(error.response?.data?.message || "Error blocking visitor");
        } finally {
            setLoad(false);
        }
    };
};
